const Unauthorized = () => {
    return <h1 className=" text-red-600 py-20 text-center text-xl font-semibold">You do not have permission to access this page.</h1>;
};

export default Unauthorized;
